import apiService from 'src/enviroment';

const polygonsService = {
  getManager: (unidad) => apiService.get(`/admin/gerentes/?unidad_negocio_id=${unidad}`),
  getManagerBosses: (unidad) => apiService.get(`/admin/gerentesjefes/?unidad_negocio_id=${unidad}`),
  getJefes: (unidad) => apiService.get(`/admin/jefes/?unidad_negocio_id=${unidad}`),
  postGerente: (body) => apiService.post('/admin/gerentes/', body),
  postGerenteJefe: (params) => apiService.post('/admin/gerentesjefes/', params),
  putManager: (params) => apiService.put('/admin/gerentes/', params),
  deleteGerente: (id) => apiService.delete(`/admin/gerentes/?id=${id}`),
  deleteGerenteTable: (rowData) => apiService.delete(
    `/admin/gerentesjefes/?gerente_id=${rowData.gerente_id}&jefe_id=${rowData.jefe_id}`,
  ),
  getJefesTerritorios: (unidad) => apiService.get(`/admin/jefesterritorios/?unidad_negocio_id=${unidad}`),
  getTerritorios: async (unidad) => {
    try {
      const response = await apiService.get(
        `/admin/territorios/?unidad_negocio_id=${unidad}`,
      );
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      return false;
    }
  },
  postJefe: (params) => apiService.post('/admin/jefes/', params),
  putJefe: (params) => apiService.put('/admin/jefes/', params),
  deleteJefe: (params) => {
    const { id } = params;
    return apiService.delete(`/admin/jefes/?id=${id}`);
  },
  postJefeTerritorio: (params) => {
    const body = {
      territorio_id: params.id,
      jefe_id: params.jefe_id,
    };
    return apiService.post('/admin/jefesterritorios/', body);
  },
  deleteJefesTabla: (rowData) => apiService.delete(
    `/admin/jefesterritorios/?territorio_id=${rowData.territorio_id}&jefe_id=${rowData.jefe_id}`,
  ),
  getTerritorioyZona: (unidad) => apiService.get(`/admin/territorioszonas/?unidad_negocio_id=${unidad}`),
  postTerritorios: (body) => apiService.post('/admin/territorios/', body),
  putTerritorios: (body) => apiService.put('/admin/territorios/', body),
  deleteTerritorio: (params) => {
    const { id } = params;
    return apiService.delete(`/admin/territorios/?id=${id}`);
  },
  postTerritoriosZonas: (params) => {
    console.log('params', params)
    const body = {
      territorio_id: params.territorio_id,
      zona_id: params.id,
    };
    return apiService.post('/admin/territorioszonas/', body);
  },
  deleteTerritorioZona: (rowData) => apiService.delete(
    `/admin/territorioszonas/?territorio_id=${rowData.territorio_id}&zona_id=${rowData.zona_id}`,
  ),
  getZonas: (unidad) => apiService.get(`/admin/zonas/?unidad_negocio_id=${unidad}`),
  deleteZonas: (id) => apiService.delete(`/admin/zonas/?id=${id}`),
  postZona: (params) => apiService.post('/admin/zonas/', params),
  putZona: (params) => {
    const body = { ...params, id: params.idzone };
    return apiService.put('/admin/zonas/', body);
  },
  getBudgets: (unidad) => apiService.get(`/admin/presupuestos/?unidad_negocio_id=${unidad}`),
  putBudget: (params) => {
    const body = {
      id: params.newData.id,
      presupuesto: params.newData.presupuesto,
    };
    return apiService.put('/admin/presupuestos/', body);
  },
  getConsolidateZones: (unidad) => apiService.get(`/admin/zonasconsolidado/?unidad_negocio_id=${unidad}`),
};

export default polygonsService;
